import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faChartLine, faDumbbell } from '@fortawesome/free-solid-svg-icons';
import { Player } from '../../domain/entities';
import './PlayerDevelopmentHistoryPanel.css';

interface PlayerDevelopmentHistoryPanelProps {
    player: Player;
}

const getIconForType = (type: 'skill' | 'attribute' | 'physical') => {
    switch (type) {
        case 'skill': return <FontAwesomeIcon icon={faStar} className="dev-icon" />;
        case 'attribute': return <FontAwesomeIcon icon={faChartLine} className="dev-icon" />;
        case 'physical': return <FontAwesomeIcon icon={faDumbbell} className="dev-icon" />;
        default: return <FontAwesomeIcon icon={faStar} className="dev-icon" />;
    }
};

export const PlayerDevelopmentHistoryPanel: React.FC<PlayerDevelopmentHistoryPanelProps> = ({ player }) => {
    const reversedHistory = [...(player.developmentHistory || [])].reverse();

    return (
        <div className="development-history-panel">
            {reversedHistory.length === 0 ? (
                <p className="text-secondary" style={{ textAlign: 'center', padding: '16px' }}>No development history recorded for this player yet.</p>
            ) : (
                <div className="table-wrapper">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>S/W</th>
                                <th>Improvement</th>
                                <th style={{ textAlign: 'center' }}>Change</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reversedHistory.map((entry, index) => (
                                <tr key={index}>
                                    <td>S{entry.season} W{entry.week}</td>
                                    <td>{getIconForType(entry.type)} {entry.description}</td>
                                    <td style={{ textAlign: 'center' }} className="positive">+{entry.change}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
